const usdRegionSuffix: Record<string, string> = {
  usa: 'USA',
  europe: 'Europe',
};

export const encodeInvoiceCurrencies = (value: string): string => {
  if (!value || value === 'all') return '';

  const tokens = value
    .split(',')
    .map((pair) => {
      const [region, currency] = pair.split('-');
      if (!currency) return '';
      if (currency !== 'USD') return currency;

      const suffix = usdRegionSuffix[region.toLowerCase()];
      return suffix ? `${currency}_${suffix}` : currency;
    })
    .filter(Boolean);

  return Array.from(new Set(tokens)).join(',');
};
